import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import {
  ContextItem,
  RequirementContextType,
  RequirementStatusViewProps
} from "../../../../types";
import { getIdentityVerificationRequirementStatus } from "./getIdentityVerificationRequirementStatus";
import { IIdentityVerificationRequestResponse } from "@wingspanhq/users";

export const getIdentityVerificationPayerRequirementStatus = (
  requirement: IRequirementResponse,
  contextItem: ContextItem,
  identityVerificationRequest: IIdentityVerificationRequestResponse | undefined
): RequirementStatusViewProps => {
  return getIdentityVerificationRequirementStatus(
    requirement,
    contextItem,
    identityVerificationRequest,
    RequirementContextType.Payee
  );
};
